//TODO Add the rest of the stop events

export enum StopEvent {
    LLD = "LLD",
    LUL = "LUL"
}